<template>
  <v-container class="align-stretch layout-container">
    <ConnectionManager />
  </v-container>
</template>

<script setup>
import ConnectionManager from '@/modules/connectionManager'
</script>
